"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9706],{

/***/ 729706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540190);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(792516);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(117321);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(667294);
/* harmony import */ var _components_Common_ReactHamburger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70440);
/* harmony import */ var _components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(629492);
/* harmony import */ var _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(313508);
/* harmony import */ var _utils_getNavList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(704956);
/* harmony import */ var _utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36408);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(186812);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66871);
/* harmony import */ var _CommonHeaderIcons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(335022);
/* harmony import */ var _CollectionHeaderDropdown__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(128036);
/* harmony import */ var _assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(452882);
/* harmony import */ var _assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(337247);
/* harmony import */ var _StoreNameComponent__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(644128);
/* harmony import */ var _ShopComponent__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(811525);
/* harmony import */ var _hooks_useSaveHeaderHeight__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(953395);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(913886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(326706);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(505152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var src_components_Wishlist_WishlistHeaderMenuItem__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(155039);


























var MegaMenuDesktopView = next_dynamic__WEBPACK_IMPORTED_MODULE_21___default()(function() {
    return __webpack_require__.e(/* import() */ 6065).then(__webpack_require__.bind(__webpack_require__, 546065)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(546065)
            ];
        }
    },
    ssr: false
});
var Header10 = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var isDesktop = _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o > 786;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    var route = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        openShop: false,
        openMore: false,
        openDropdown: false
    }), open = ref6[0], setOpen = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        desktop: false,
        mobile: false
    }), openMegaMenu = ref7[0], setOpenMegaMenu = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), openCollections = ref8[0], setOpenCollections = ref8[1];
    var ref9 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_20__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            navigationList: state.additionalPagesReducer.navigationList,
            collections: state.catalogReducer.collections
        };
    }), storeData = ref9.storeData, navigationList = ref9.navigationList, collections = ref9.collections;
    var navItemsState = (0,_utils_getNavList__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(navigationList);
    var ref10 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            items: state.cartReducer.items,
            user: state.userReducer
        };
    }), items = ref10.items, user = ref10.user;
    var headerBgColor = (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.color_scheme) === null || ref1 === void 0 ? void 0 : ref1.bg_color) || "#FFFFFF";
    var headerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    (0,_hooks_useSaveHeaderHeight__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(headerRef);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!open.openDropdown) setOpenCollections(false);
    }, [
        open.openDropdown
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(navigationList === null || navigationList === void 0 ? void 0 : navigationList.length)) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .getNavigationPagesList */ .A7)({
                storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                isPublished: true
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        navigationList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        if (isDesktop) {
            if (ref5.current && ref5.current.contains(e.target)) {
                return;
            }
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, state), {
                    openShop: false,
                    openMore: false
                });
            });
        }
    };
    var clickForRoute = function(route) {
        var ref;
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(route, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var handleCartClick = function() {
        if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_11__/* .getStoreType */ .K)(storeData) === _utils_constants__WEBPACK_IMPORTED_MODULE_19__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_26__/* .toggleRfqFormModal */ .H4)());
            return;
        }
        clickForRoute(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.CART);
    };
    var menuItemClick = function(nav) {
        if ((openMegaMenu === null || openMegaMenu === void 0 ? void 0 : openMegaMenu.desktop) || (openMegaMenu === null || openMegaMenu === void 0 ? void 0 : openMegaMenu.mobile)) {
            setOpenMegaMenu(function() {
                return {
                    desktop: false,
                    mobile: false
                };
            });
        }
        if ((nav === null || nav === void 0 ? void 0 : nav.page_type) === "blank_page" && (nav === null || nav === void 0 ? void 0 : nav.is_external_url)) {
            window.open(nav.slug_url, "_blank");
            return;
        }
        if (nav.slug_url === "shop") {
            if (document.querySelector("#CollectionCategoryProductWidget")) {
                document.querySelector("#CollectionCategoryProductWidget").scrollIntoView();
            } else {
                var ref;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
            }
        } else if (nav.slug_url === "subNavList") {
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, state), {
                    openMore: !open.openMore
                });
            });
        } else {
            if (nav.is_editable) {
                var ref1;
                window.location.href = (0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.additionalPage(nav.slug_url), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
            } else {
                var ref2;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(nav.slug_url, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            }
        }
    };
    var toggleDropdown = function() {
        setOpen(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, state), {
                openDropdown: !state.openDropdown
            });
        });
    };
    var routeMatchForActiveLink = function(url) {
        return "/[domain]".concat(url ? "/".concat(url) : "") === route.pathname ? "menu-item-active" : "";
    };
    var closeShopDropdown = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        return setOpen(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, state), {
                openShop: false,
                openDropdown: false
            });
        });
    }, []);
    var navSubList = function(nav) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "cfe-dropdown-nav",
            ref: ref5,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cfe-dropdown-nav__items",
                children: nav.map(function(n) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cfe-dropdown-nav__item",
                        onClick: function() {
                            return menuItemClick(n);
                        },
                        children: n.page_name
                    }, n.page_id);
                })
            })
        });
    };
    var handleShopClick = function(page, dropdownNav) {
        if ((0,_utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_9__/* .showMegaMenu */ .G)()) {
            _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_7__/* .IS_DESKTOP */ .yn ? setOpenMegaMenu(function() {
                return {
                    mobile: false,
                    desktop: !openMegaMenu.desktop
                };
            }) : setOpenMegaMenu(function() {
                return {
                    desktop: false,
                    mobile: !openMegaMenu.mobile
                };
            });
        } else {
            if (collections === null || collections === void 0 ? void 0 : collections.length) {
                if (dropdownNav) {
                    setOpenCollections(true);
                } else {
                    menuItemClick(page);
                }
            } else {
                setOpen(function(state) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, state), {
                        openShop: true,
                        openMore: false
                    });
                });
            }
        }
    };
    var renderNavType = function(page) {
        var dropdownNav = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        switch(page.slug_url){
            case "":
                var ref, ref1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3 visible-mobile",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_14__/* .HeaderHome */ .Q, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: page.page_name
                                })
                            ]
                        })
                    })
                }, page.page_id);
            case "shop":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShopComponent__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    ref: ref5,
                    page: page,
                    dropdownNav: dropdownNav,
                    handleShopClick: handleShopClick,
                    setOpenMegaMenu: setOpenMegaMenu,
                    open: open,
                    closeShopDropdown: closeShopDropdown,
                    showMegaMenuMobile: openMegaMenu,
                    bgColor: headerBgColor
                });
            case "subNavList":
                var ref2;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center",
                                    style: {
                                        flex: "1 1 auto"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "More"
                                    })
                                }),
                                (page === null || page === void 0 ? void 0 : (ref2 = page.subNavs) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                    alt: "dropdown button",
                                    style: {
                                        transform: "rotate(90deg)",
                                        width: 7,
                                        marginLeft: dropdownNav ? "0px" : "8px"
                                    }
                                })
                            ]
                        }),
                        open.openMore && navSubList(page.subNavs)
                    ]
                }, page.page_id);
            case "about-us":
                var ref3, ref4;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3 visible-mobile",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_15__/* .HeaderInfoIcon */ .V, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: page.page_name
                                })
                            ]
                        })
                    })
                }, page.page_id);
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item ".concat(routeMatchForActiveLink(page.slug_url)),
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: page.page_name
                }, page.page_id);
        }
    };
    var searchBar = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "search-comp flex items-center justify-center pointer w-100",
            onClick: function() {
                return clickForRoute(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.SEARCH);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/nmNB3Y56.webp",
                    className: "mr2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "ttu",
                    children: "Search"
                })
            ]
        });
    };
    var leftSection = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "visible-desktop-flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StoreNameComponent__WEBPACK_IMPORTED_MODULE_16__/* .StoreNameComp */ ._, {
                        showLogo: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "visible-mobile-flex w-100",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_ReactHamburger__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        open: open.openDropdown,
                        setOpen: toggleDropdown,
                        theme: "#000000"
                    })
                })
            ]
        });
    };
    var middleSection = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "visible-desktop-flex",
            children: searchBar()
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        ref: headerRef,
        className: "header10 collection-header",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "header10__top-component",
                children: [
                    leftSection(),
                    middleSection(),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "flex items-center justify-end icon-set visible-desktop",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "tw-ml-5",
                                onClick: function() {
                                    var ref;
                                    next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.WISHLIST, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Wishlist_WishlistHeaderMenuItem__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                    color: (storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color) !== "#ffffff" ? "#000000" : "#ffffff",
                                    showComponent: "icon"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "icon-set-image",
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/SPz76B8j.webp"
                                        }),
                                        (user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            alt: "dropdown button",
                                            src: "/assets/images/down-arrow-thin.svg",
                                            className: "ml2 arrow-icon"
                                        }) : ""
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                onClick: handleCartClick,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "icon-set-image",
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/knl2aF18.webp"
                                    }),
                                    (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "cart-items absolute z-2",
                                        children: items.length
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "visible-mobile",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonHeaderIcons__WEBPACK_IMPORTED_MODULE_12__/* .CommonHeaderIconsMobile */ .r, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "header10__bottom-component w-100 visible-desktop",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "visible-desktop-flex w-100 justify-center",
                    children: (navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "header10__bottom-component--menu",
                        children: navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.map(function(nav) {
                            return renderNavType(nav, true);
                        })
                    })
                })
            }),
            openMegaMenu.desktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MegaMenuDesktopView, {
                open: openMegaMenu.desktop,
                onClose: function() {
                    return setOpenMegaMenu({
                        desktop: false,
                        mobile: false
                    });
                }
            }),
            open.openDropdown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionHeaderDropdown__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                renderNavType: renderNavType,
                navItemsState: navItemsState,
                openCollections: openCollections,
                goBack: function() {
                    return setOpenCollections(false);
                },
                collectionListType: (props === null || props === void 0 ? void 0 : (ref4 = props.config) === null || ref4 === void 0 ? void 0 : ref4.name) || null
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Header10);


/***/ }),

/***/ 155039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(407056);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(298627);
/* harmony import */ var src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(482516);





var WishlistIcon = function(param) {
    var color = param.color, iconSize = param.iconSize, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        color: color,
        iconSize: iconSize,
        isActive: isActive
    });
};
var WishlistText = function(param) {
    var _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Wishlist" : _ctaText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "tw-font-inter tw-text-[17px] tw-font-normal ".concat(customTextClassName),
        children: ctaText
    });
};
var WishlistBoth = function(param) {
    var color = param.color, iconPosition = param.iconPosition, iconSize = param.iconSize, wrapperClassName = param.wrapperClassName, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, ctaText = param.ctaText, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-gap-[10px] tw-items-center ".concat(wrapperClassName),
        children: iconPosition === "right" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                })
            ]
        })
    });
};
var WishlistHeaderMenuItem = function(param) {
    var color = param.color, iconSize = param.iconSize, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "right" : _iconPosition, _showComponent = param.showComponent, showComponent = _showComponent === void 0 ? "both" : _showComponent, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _wrapperClassName = param.wrapperClassName, wrapperClassName = _wrapperClassName === void 0 ? "" : _wrapperClassName, ctaText = param.ctaText, isActive = param.isActive, onClick = param.onClick;
    var wishlistFeatureActive = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return {
            wishlistFeatureActive: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag
        };
    }).wishlistFeatureActive;
    var wishlistFeatureStatus = (0,src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureLocks */ .r)().wishlistFeatureStatus;
    if (wishlistFeatureActive !== _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE || (wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked)) {
        return null;
    }
    if (showComponent === "icon") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
            color: color,
            iconSize: iconSize,
            isActive: isActive
        })
    });
    if (showComponent === "text") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
            customTextClassName: customTextClassName,
            ctaText: ctaText
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistBoth, {
            color: color,
            iconPosition: iconPosition,
            iconSize: iconSize,
            wrapperClassName: wrapperClassName,
            customTextClassName: customTextClassName,
            ctaText: ctaText,
            isActive: isActive
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WishlistHeaderMenuItem);


/***/ })

}]);